import axios from 'axios'
// import crypto from 'crypto'
axios.defaults.baseURL = 'http://111.229.214.104:8000'


const state = {
logis:'',
token : '',
}

const mutations = {
// LOGIN(state,data) {
//   state.logis = data;
//   state.token = data.code;
// if(data.code) {
//   localStorage.setItem('user',data.code)
// }else {
//   return false
// }

//   // window.$cookies.set('token', data.code , 60*60*24)
// }
}

 // + data.mobile + '&password=' + data.password + '&password2=' + data.password2 + '&sms_code=' + data.sms_code + '&username=' + data.username + '&allow=on'
const actions = {
//微信登录
wxLogin({ commit },data) {
  commit('WX_LOGIN');
  return axios.get('wxLogin/?code=' + data).then((res) => {
    return res
  })
},
  // 登录
 Login ({ commit },data) {
   // console.log(data)
   commit('LOGIN')
   return axios.post('/login/', data, { withCredentialls: true }).then(response => {
     return response
   })
 },
 // 退出登录
 deleta({ commit },data) {
   // console.log(data)
   commit('LOGIN_OUT')
   return axios.get('/logout/?token=' + data).then((res) => {
     return res
   })
 },
 // 微信登录
 Wxlogin({ commit }) {
   commit('Wxlogin')
   let url = 'https://open.weixin.qq.com/connect/qrconnect?appid=wxe2a57f2f14b324e6&redirect_uri=http://5thclassroom.cn/wxLogin/ &response_type=code&scope=snsapi_login&state=STATE#wechat_redirect'
   return axios.get(url).then((res) => {
     return res
   })
 }
}

const getters = {

}

const LoginModule = {
  state,
  mutations,
  actions,
  getters
}

export default LoginModule
